import styled from 'styled-components';
import { UpdateIcon } from '../../assets/icons/UpdateIcon';
import Typography from '../typography/Typography';
import Button from '../button/Button';

interface Props {
  handleUpdateTasks: () => void;
  header: string;
  subheader?: string;
  button: JSX.Element;
}

const TechnicianHeader = (props: Props) => {
  const { handleUpdateTasks, header, button, subheader } = props;

  const onClickUpdateTasks: React.MouseEventHandler = (e) => {
    e.stopPropagation();
    handleUpdateTasks();
  };

  return (
    <TechnicianHeaderContainer data-testid="dayOverviewHeader">
      <TextContainer>
        <Typography variant="h3">{header}</Typography>
        {subheader && <Typography>{subheader}</Typography>}
      </TextContainer>
      <StyledRightDiv>
        <StyledUpdateButton variant="secondary" onClick={onClickUpdateTasks}>
          <UpdateIcon size="20px" />
        </StyledUpdateButton>
        {button}
      </StyledRightDiv>
    </TechnicianHeaderContainer>
  );
};

export const TechnicianHeaderContainer = styled.div`
  height: 100px;
  padding: 0 ${(props) => props.theme.spacing(6)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1px;
  background-color: ${(props) => props.theme.palette.background.tertiary};
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
`;

const StyledRightDiv = styled.div`
  display: flex;
  align-items: center;
`;

const StyledUpdateButton = styled(Button)`
  border-radius: 100px;
  padding: 10px;
  margin: 0px 20px;
`;

export default TechnicianHeader;
